const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the content liked by component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {BulkUsers} BulkUsers the service defined to manage BulkUsers
 * @argument {Invitations} Invitations the service defined to manage Invitations
 * @argument {$http} $http the service defined to manage $http
 * @argument {$q} $q the service defined to manage $q
 */
app.directive('addUserMultiple', ['Application', 'AccessHelper', '$http', 'BulkUsers', 'Invitations', '$q', function (Application, AccessHelper, $http, BulkUsers, Invitations, $q) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../../templates/directives/add-user-multiple.html'),
    controller: ['$scope', function ($scope) {
      var self = this;

      self.allowance = {
        add: AccessHelper.isAllowed(['admin', 'users'], null, ['admin', 'manager'])
      };

      if (!self.allowance.add) {
        Application.navigation.goTo('/explore');
        return;
      }

      self.loading = false;
      self.uploaderId = 'fileUpload';
      self.showModal = false;
      self.overview = false;
      self.deleteList = [];

      self.toggleUser = function(email) {
        var user = self.users.toAdd[email] ? self.users.toAdd[email] : self.users.duplicate[email];
        if (!user.remove) {
          user.remove = true;
          self.deleteList.push(user);
          return;
        }

        user.remove = false;
        for (var i = 0; i < self.deleteList.length; i++) {
          if (user.email === email) {
            self.deleteList.splice(i, 1);
            return;
          }
        }
      };

      self.removeUsers = function() {
        for (var i = 0; i < self.deleteList.length; i++) {
          delete self.users.toAdd[self.deleteList[i].email];
          delete self.users.duplicate[self.deleteList[i].email];
        }

        self.deleteList = [];
      };

      self.checkLength = function(type) {
        if (!self.users) {
          return;
        }

        return Object.keys(self.users[type]).length;
      };

      self.submitUsers = function() {
        self.submitLoading = true;
        var adds = [];
        var updates = [];

        for (var email in self.users.toAdd) {
          adds.push(self.users.toAdd[email]);
        }
        for (var key in self.users.duplicate) {
          updates.push(self.users.duplicate[key]);
        }

        if (adds.length && updates.length) {
          $q.all(BulkUsers.bulkUpdate(updates), Invitations.bulkInvite({invites: adds}).$promise)
          .then(function(data) {
            self.submitLoading = false;
            Application.messaging.addMessage({type: 'success', text: 'Success. All invitations and/or updates have been made.', duration: 5});
            Application.navigation.goTo('/users');
          }).catch(function(err) {
            self.submitLoading = false;
            Application.messaging.addMessage({type: 'error', text: 'Error. Completing this action.', duration: 5});
            Application.navigation.goTo('/users');
            console.log(err);
          });
          return;
        }
        if (updates.length) {
          BulkUsers.bulkUpdate(updates)
          .then(function(updated) {
            self.submitLoading = false;
            Application.messaging.addMessage({type: 'success', text: 'Success. All updates have been made.', duration: 5});
            Application.navigation.goTo('/users');
          }).catch(function(err) {
            Application.messaging.addMessage({type: 'error', text: 'Error. Completing this action.', duration: 5});
            self.submitLoading = false;
            console.log('Error in Updates: ', err)
          })
          return;
        }

        Invitations.bulkInvite({invites: adds}).$promise
        .then(function(added) {
          self.submitLoading = false;
          Application.messaging.addMessage({type: 'success', text: 'Success. All invitations have been made.', duration: 5});
          Application.navigation.goTo('/users');
        }, function(err) {
          Application.messaging.addMessage({type: 'error', text: 'Error. Completing this action.', duration: 5});
          self.submitLoading = false;
          console.log('Error in Invites: ', err)
        })
      };

      $scope.$watch('usersAdd.file', function(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          self.loading = true;

          var formData = new FormData();
          formData.append('file', self.file);

          $http.post(Application.API + '/learn/v3/users/multiple', formData, {
            withCredentials : false,
            headers : {
             'Content-Type' : undefined
            },
            transformRequest : angular.identity
          })
          .then(function(response) {
            var data = response.data;
            self.userLists = {};
            for (var key in data) {
              self.userLists[key] = Object.keys(data[key]);
            }
            self.users = data;
            self.loading = false;
            self.showModal = true;
            self.overview = true;
          })
          .catch(function(response) {
            console.log('Invalid csv.')
          });
        }
      });

      self.openBrowse = function() {
        document.getElementById(self.uploaderId).click();
      };

    }],
    controllerAs: 'usersAdd'
  };
}]);

